export const Footer = () => {
  return (
    <footer className="bg-header-bg flex flex-col justify-center items-center md:py-3 py-2 px-2 text-xs md:text-sm gap-1">
      <span className="text-white text-center flex flex-wrap justify-center gap-1">
        <span>Copyright © 2024 Hanlin</span>
        <span>翰林出版事業股份有限公司</span>
      </span>
      <a
        href="/privacy"
        className="text-third text-center"
      >
        使用者條款與免責聲明
      </a>
    </footer>
  );
};